import React from 'react';

const BodyMap = ({ selectedMuscles, onToggleMuscle, onSelectFullBody }) => {
  const isSelected = (muscle) => selectedMuscles.includes(muscle);
  const isFullBody = selectedMuscles.includes('full_body');

  const muscleColors = {
    shoulders: '#32CD32',
    chest: '#32CD32',
    biceps: '#32CD32',
    triceps: '#32CD32',
    core: '#32CD32',
    quadriceps: '#32CD32',
    calves: '#32CD32',
    back: '#32CD32',
    glutes: '#32CD32'
  };

  const muscleLabels = {
    shoulders: 'Ombros',
    chest: 'Peitoral',
    biceps: 'Bíceps',
    triceps: 'Tríceps',
    core: 'Abdominal',
    quadriceps: 'Quadríceps',
    calves: 'Gémeos',
    back: 'Costas',
    glutes: 'Glúteos'
  };

  const handleMuscleClick = (muscle) => {
    onToggleMuscle(muscle);
  };

  const handleFullBodyClick = () => {
    if (onSelectFullBody) {
      onSelectFullBody();
    } else {
      onToggleMuscle('full_body');
    }
  };

  // All muscles in one view
  const allMuscles = ['shoulders', 'chest', 'back', 'biceps', 'triceps', 'core', 'glutes', 'quadriceps', 'calves'];

  return (
    <div className="flex flex-col items-center gap-5">
      {/* Muscle Selection Buttons */}
      <div className="grid grid-cols-3 gap-3 w-full max-w-[400px]">
        {allMuscles.map((muscle) => (
          <button
            key={muscle}
            type="button"
            onClick={() => handleMuscleClick(muscle)}
            data-testid={`muscle-btn-${muscle}`}
            className={`px-4 py-3 rounded-xl text-sm font-medium transition-all border-2 ${
              isSelected(muscle) || isFullBody
                ? 'shadow-lg'
                : 'border-white/10 bg-black/30 text-gray-400 hover:border-white/30 hover:text-white'
            }`}
            style={
              isSelected(muscle) || isFullBody
                ? { 
                    backgroundColor: `${muscleColors[muscle]}25`,
                    color: muscleColors[muscle],
                    borderColor: muscleColors[muscle]
                  }
                : {}
            }
          >
            {muscleLabels[muscle]}
          </button>
        ))}
      </div>

      {/* Selected muscles tags */}
      <div className="flex flex-wrap gap-2 justify-center min-h-[32px]">
        {isFullBody ? null : selectedMuscles.length === 0 ? (
          <span className="text-gray-500 text-sm">Seleciona os músculos acima</span>
        ) : (
          selectedMuscles.filter(m => m !== 'full_body').map(muscle => (
            <span 
              key={muscle}
              onClick={() => handleMuscleClick(muscle)}
              className="px-3 py-1 rounded-full text-xs font-medium cursor-pointer hover:opacity-80 transition-opacity flex items-center gap-1"
              style={{ 
                backgroundColor: `${muscleColors[muscle]}30`,
                color: muscleColors[muscle],
                border: `1px solid ${muscleColors[muscle]}50`
              }}
            >
              {muscleLabels[muscle]} 
              <span className="opacity-70">✕</span>
            </span>
          ))
        )}
      </div>

      {/* Full body button */}
      <button
        type="button"
        onClick={handleFullBodyClick}
        data-testid="full-body-btn"
        className={`px-6 py-2.5 rounded-xl border-2 transition-all text-sm font-medium ${
          isFullBody
            ? 'bg-[#32CD32]/20 border-[#32CD32] text-[#32CD32] shadow-lg shadow-[#32CD32]/20'
            : 'border-white/20 text-gray-400 hover:border-[#32CD32]/50 hover:text-[#32CD32]'
        }`}
      >
        {isFullBody ? '✓ Corpo Inteiro' : 'Selecionar Corpo Inteiro'}
      </button>
    </div>
  );
};

export default BodyMap;
